"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoreDataDictionaryViewsSharedKeyAsyncSlice = void 0;
const get_1 = require("../../../customers/current/feature-flags/get.js");
const name_1 = require("./name.js");
const get_2 = require("../../../stakeholders/get.js");
const get_3 = require("../../../tags/get.js");
const get_4 = require("../../../users/all/get.js");
const get_5 = require("../../../users/current/get.js");
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../../../api/index.js");
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
const actions_1 = require("../../../data-security/applications/_idMap/actions.js");
const actions_2 = require("../../../sonar-objects/_idMap/actions.js");
const actions_3 = require("../../../stakeholders/_idMap/actions.js");
const actions_4 = require("../../../tags/_idMap/actions.js");
const actions_5 = require("../../../users/_idMap/actions.js");
const get_6 = require("../../get.js");
const { receiveGetCoreCustomersCurrentFeatureFlags } = get_1.coreCustomersCurrentFeatureFlagsGetAsyncSlice.asyncActionCreators;
const { receiveGetCoreUsersAll } = get_4.coreUsersAllGetAsyncSlice.asyncActionCreators;
const { receiveGetCoreUsersCurrent } = get_5.coreUsersCurrentGetAsyncSlice.asyncActionCreators;
const { receiveGetCoreStakeholders } = get_2.coreStakeholdersGetAsyncSlice.asyncActionCreators;
const { receiveGetCoreTags } = get_3.coreTagsGetAsyncSlice.asyncActionCreators;
exports.getCoreDataDictionaryViewsSharedKeyAsyncSlice = (0, xuder_1.createGetAsyncSlice)({
    httpSagaOptions: {
        preRequestActionCreators: [
            () => receiveGetCoreUsersCurrent({
                isGuest: true,
                isReadOnly: true
            }),
            () => receiveGetCoreCustomersCurrentFeatureFlags({})
        ],
        successDataActionCreators: [
            (response) => receiveGetCoreUsersAll({
                results: response.owners.map((owner) => {
                    const [firstName, lastName] = owner.name.split(' ');
                    return {
                        firstName,
                        fullName: owner.name,
                        id: owner.id,
                        lastName
                    };
                })
            }),
            (response) => (0, actions_5.updateUserReferences)(response.owners.map((owner) => {
                const [firstName, lastName] = owner.name.split(' ');
                return {
                    firstName,
                    fullName: owner.name,
                    lastName,
                    userId: owner.id
                };
            })),
            (response) => receiveGetCoreStakeholders(response.stakeholders.map((stakeholder) => ({
                name: stakeholder.name,
                stakeholderId: stakeholder.id,
                userId: stakeholder.userId
            }))),
            (response) => (0, actions_3.updateStakeholderReferences)(response.stakeholders.map((stakeholder) => ({
                name: stakeholder.name,
                stakeholderId: stakeholder.id,
                userId: stakeholder.userId
            }))),
            (response) => (0, actions_5.updateUserReferences)(response.stakeholders
                .filter((stakeholder) => Boolean(stakeholder.userId))
                .map((stakeholder) => {
                const [firstName, lastName] = stakeholder.name.split(' ');
                return {
                    firstName,
                    fullName: stakeholder.name,
                    lastName,
                    userId: stakeholder.userId
                };
            })),
            (response) => receiveGetCoreTags(response.tags.map((tag) => ({
                autoTagged: false,
                description: '',
                hexColor: tag.color,
                id: tag.id,
                name: tag.name,
                ownerIds: []
            }))),
            (response) => (0, actions_4.updateTagReferences)(response.tags.map((tag) => ({
                autoTagged: false,
                description: '',
                hexColor: tag.color,
                id: tag.id,
                name: tag.name,
                ownerIds: []
            }))),
            (response) => (0, actions_1.updateApplicationReferences)(response.applications),
            (response) => {
                const context = response.results.map((result) => (result.isCustom === undefined ?
                    (0, get_6.buildUpdateForField)(result) :
                    (0, get_6.buildUpdateForObject)(result, sonar_ts_types_1.SonarObjectType.SalesforceEntity)));
                return (0, actions_2.updateSonarObjectReferences)(context);
            }
        ]
    },
    name: name_1.CoreDataDictionaryViewsSharedKeyName,
    receive: true,
    request: true,
    requestHandler: _api_1.getSharedDataDictionary,
    retainDataOnRequest: true
});
//# sourceMappingURL=get.js.map